export type OfficialDocument = {
  name: string;
  url: string;
  updatedAt: string;
  updatedBy: string;
};

export type ResponseOfficialDocument = {
  updated_user_name: string;
  official_document_file_name: string;
  official_document_file_uploaded_at: string;
  official_document_file_url: string;
};

export const buildOfficialDocument = (
  res: ResponseOfficialDocument,
): OfficialDocument => {
  return {
    name: res.official_document_file_name,
    url: res.official_document_file_url,
    updatedAt: res.official_document_file_uploaded_at,
    updatedBy: res.updated_user_name,
  };
};
